module.exports = __webpack_public_path__ + "img/4.107f666a.jpg";